import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "p-signup-profile l-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-signup-profile__ttl c-ttl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-signup-profile__ttl__logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "SHUEISHA ID"
    })
  ]),
  /*#__PURE__*/_createTextVNode("会員情報登録")
], -1)
const _hoisted_3 = { class: "p-signup-profile__field-container" }
const _hoisted_4 = { class: "p-fields" }
const _hoisted_5 = { class: "c-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "プロフィール画像", -1)
const _hoisted_7 = { class: "c-field__body" }
const _hoisted_8 = { class: "c-field__file" }
const _hoisted_9 = { class: "upload-img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "upload-cap" }, [
  /*#__PURE__*/_createTextVNode("※JPEG/GIF/PNG/BMP形式が使用可能です。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※著作権等の侵害にあたらない画像を使用してください。")
], -1)
const _hoisted_12 = { class: "c-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "lastName"
}, "お名前", -1)
const _hoisted_14 = { class: "c-field__body" }
const _hoisted_15 = { class: "c-field__input has-horizontal-item" }
const _hoisted_16 = { class: "c-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "lastKana"
}, "ふりがな", -1)
const _hoisted_18 = { class: "c-field__body" }
const _hoisted_19 = { class: "c-field__input has-horizontal-item" }
const _hoisted_20 = { class: "c-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "nickname"
}, [
  /*#__PURE__*/_createTextVNode("ニックネーム"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_22 = { class: "c-field__body" }
const _hoisted_23 = { class: "c-field__input" }
const _hoisted_24 = { class: "c-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, [
  /*#__PURE__*/_createTextVNode("性別"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_26 = { class: "c-field__body" }
const _hoisted_27 = { class: "c-field__radio" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "gender_female" }, "女性", -1)
const _hoisted_29 = { class: "c-field__radio" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "gender_male" }, "男性", -1)
const _hoisted_31 = { class: "c-field__radio" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "gender_other" }, "その他", -1)
const _hoisted_33 = { class: "c-field__radio" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "gender_noanswer" }, "回答しない", -1)
const _hoisted_35 = { class: "c-field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, [
  /*#__PURE__*/_createTextVNode("誕生日"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_37 = { class: "c-field__body" }
const _hoisted_38 = { class: "c-field__select" }
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "c-field__select" }
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "c-field__select" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "c-field" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "結婚の有無", -1)
const _hoisted_46 = { class: "c-field__body" }
const _hoisted_47 = { class: "c-field__radio" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "married" }, "既婚", -1)
const _hoisted_49 = { class: "c-field__radio" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "single" }, "未婚", -1)
const _hoisted_51 = { class: "c-field" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "子供の有無", -1)
const _hoisted_53 = { class: "c-field__body" }
const _hoisted_54 = { class: "c-field__radio" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "yes" }, "有り", -1)
const _hoisted_56 = { class: "c-field__radio" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "no" }, "無し", -1)
const _hoisted_58 = { class: "c-field" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "血液型", -1)
const _hoisted_60 = { class: "c-field__body" }
const _hoisted_61 = { class: "c-field__radio" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { for: "A" }, "A型", -1)
const _hoisted_63 = { class: "c-field__radio" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { for: "B" }, "B型", -1)
const _hoisted_65 = { class: "c-field__radio" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { for: "O" }, "O型", -1)
const _hoisted_67 = { class: "c-field__radio" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { for: "AB" }, "AB型", -1)
const _hoisted_69 = { class: "c-field__radio" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { for: "unknown" }, "不明", -1)
const _hoisted_71 = { class: "c-field" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "zipCode"
}, [
  /*#__PURE__*/_createTextVNode("郵便番号"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_73 = { class: "c-field__body" }
const _hoisted_74 = { class: "c-field__input has-horizontal-item" }
const _hoisted_75 = { class: "c-field" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "prefecture"
}, [
  /*#__PURE__*/_createTextVNode("都道府県"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_77 = { class: "c-field__body" }
const _hoisted_78 = { class: "c-field__select" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1)
const _hoisted_80 = ["value"]
const _hoisted_81 = { class: "c-field" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "address"
}, "住所", -1)
const _hoisted_83 = { class: "c-field__body" }
const _hoisted_84 = { class: "c-field__input has-vertical-item" }
const _hoisted_85 = { class: "c-field" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "tel"
}, "電話番号", -1)
const _hoisted_87 = { class: "c-field__body" }
const _hoisted_88 = { class: "c-field__input" }
const _hoisted_89 = { class: "c-field" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "agreement"
}, [
  /*#__PURE__*/_createTextVNode("規約/ガイドライン"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_91 = { class: "c-field__body" }
const _hoisted_92 = {
  class: "c-field__checkbox",
  for: "agreement"
}
const _hoisted_93 = /*#__PURE__*/_createTextVNode("集英社ID利用規約")
const _hoisted_94 = /*#__PURE__*/_createTextVNode("、")
const _hoisted_95 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www2.shueisha.co.jp/privacy/privacy.html",
  target: "_blank"
}, "集英社 プライバシーガイドライン", -1)
const _hoisted_96 = /*#__PURE__*/_createTextVNode("に同意する")
const _hoisted_97 = { class: "c-field has-submit has-mt" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", null, "登録する", -1)
const _hoisted_100 = [
  _hoisted_99
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Form, {
      onSubmit: _ctx.register,
      "validation-schema": _ctx.schema,
      ref: "formRef"
    }, {
      default: _withCtx(({ errors, meta }) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("fieldset", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "upload-btn",
                    title: "Upload image",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.operationImage && _ctx.operationImage(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_9, [
                      _createElementVNode("img", {
                        src: (_ctx.image.path) ? _ctx.image.path : require('@/assets/images/common/img_user-default.svg'),
                        alt: "Upload image"
                      }, null, 8, _hoisted_10)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["upload-icon", { 'is-delete':_ctx.isDeleteRef }])
                    }, null, 2)
                  ]),
                  _hoisted_11
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(_ctx.imageErrorMsgRef), 513), [
              [_vShow, _ctx.imageErrorMsgRef]
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "lastName",
                    name: "lastName",
                    modelValue: _ctx.userBase.baseInfo.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userBase.baseInfo.lastName) = $event)),
                    placeholder: "姓",
                    autocomplete: "family-name"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "firstName",
                    name: "firstName",
                    modelValue: _ctx.userBase.baseInfo.firstName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userBase.baseInfo.firstName) = $event)),
                    placeholder: "名",
                    autocomplete: "given-name"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.lastName), 513), [
              [_vShow, errors.lastName]
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.firstName), 513), [
              [_vShow, errors.firstName]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "lastKana",
                    name: "lastKana",
                    modelValue: _ctx.userBase.baseInfo.lastKana,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userBase.baseInfo.lastKana) = $event)),
                    placeholder: "せい"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "firstKana",
                    name: "firstKana",
                    modelValue: _ctx.userBase.baseInfo.firstKana,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userBase.baseInfo.firstKana) = $event)),
                    placeholder: "めい"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.lastKana), 513), [
              [_vShow, errors.lastKana]
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.firstKana), 513), [
              [_vShow, errors.firstKana]
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "nickname",
                    name: "nickname",
                    modelValue: _ctx.userBase.commonAttrInfo.nickName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userBase.commonAttrInfo.nickName) = $event)),
                    placeholder: "○○○○○○○○",
                    required: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.nickname), 513), [
              [_vShow, errors.nickname]
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "gender_female",
                    name: "gender",
                    value: "女性",
                    modelValue: _ctx.userBase.commonAttrInfo.gender,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "gender_male",
                    name: "gender",
                    value: "男性",
                    modelValue: _ctx.userBase.commonAttrInfo.gender,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_30
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "gender_other",
                    name: "gender",
                    value: "その他",
                    modelValue: _ctx.userBase.commonAttrInfo.gender,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_32
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "gender_noanswer",
                    name: "gender",
                    value: "無回答",
                    modelValue: _ctx.userBase.commonAttrInfo.gender,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_34
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.gender), 513), [
              [_vShow, errors.gender]
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("select", {
                    ref: "yearRef",
                    name: "year",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.date.year) = $event)),
                    required: "",
                    onMouseup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.birthdayValidate()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year, idx) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: idx,
                        value: year
                      }, _toDisplayString(year), 9, _hoisted_39))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.date.year]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("select", {
                    ref: "monthRef",
                    name: "month",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.date.month) = $event)),
                    required: "",
                    onMouseup: _cache[13] || (_cache[13] = ($event: any) => (_ctx.birthdayValidate()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, idx) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: idx,
                        value: month
                      }, _toDisplayString(month), 9, _hoisted_41))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.date.month]
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("select", {
                    ref: "dayRef",
                    name: "day",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.date.day) = $event)),
                    required: "",
                    onMouseup: _cache[15] || (_cache[15] = ($event: any) => (_ctx.birthdayValidate()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date, idx) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: idx,
                        value: date
                      }, _toDisplayString(date), 9, _hoisted_43))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.date.day]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "birthday",
                    modelValue: _ctx.birthday,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.birthday) = $event)),
                    style: {"display":"none"}
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.birthday), 513), [
              [_vShow, errors.birthday]
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "married",
                    name: "isMarried",
                    value: true,
                    modelValue: _ctx.userBase.commonAttrInfo.isMarried,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.userBase.commonAttrInfo.isMarried) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_48
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "single",
                    name: "isMarried",
                    value: false,
                    modelValue: _ctx.userBase.commonAttrInfo.isMarried,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.userBase.commonAttrInfo.isMarried) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_50
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.isMarried), 513), [
              [_vShow, errors.isMarried]
            ]),
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "yes",
                    name: "hasChild",
                    value: true,
                    modelValue: _ctx.userBase.commonAttrInfo.hasChild,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.userBase.commonAttrInfo.hasChild) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_55
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "no",
                    name: "hasChild",
                    value: false,
                    modelValue: _ctx.userBase.commonAttrInfo.hasChild,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.userBase.commonAttrInfo.hasChild) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_57
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.hasChild), 513), [
              [_vShow, errors.hasChild]
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "A",
                    name: "bloodType",
                    value: "A",
                    modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_62
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "B",
                    name: "bloodType",
                    value: "B",
                    modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_64
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "O",
                    name: "bloodType",
                    value: "O",
                    modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_66
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "AB",
                    name: "bloodType",
                    value: "AB",
                    modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_68
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_Field, {
                    type: "radio",
                    id: "unknown",
                    name: "bloodType",
                    value: "不明",
                    modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_70
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.bloodType), 513), [
              [_vShow, errors.bloodType]
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "zipCode",
                    name: "zipCode",
                    modelValue: _ctx.userBase.baseInfo.zipCode,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.userBase.baseInfo.zipCode) = $event)),
                    placeholder: "0000000",
                    autocomplete: "postal-code",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("a", {
                    class: "c-link c-link--primary",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.addressAutoFill()))
                  }, "住所を検索する")
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.zipCode), 513), [
              [_vShow, errors.zipCode]
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createVNode(_component_Field, {
                    as: "select",
                    id: "prefecture",
                    name: "prefecture",
                    modelValue: _ctx.userBase.baseInfo.prefecture,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.userBase.baseInfo.prefecture) = $event)),
                    autocomplete: "address-level1",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_79,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefectureList, (item, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: idx,
                          value: item
                        }, _toDisplayString(item), 9, _hoisted_80))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.prefecture), 513), [
              [_vShow, errors.prefecture]
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "address",
                    name: "address",
                    modelValue: _ctx.userBase.baseInfo.address,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.userBase.baseInfo.address) = $event)),
                    placeholder: "市区町村番地",
                    autocomplete: "address-line1"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "building",
                    name: "building",
                    modelValue: _ctx.userBase.baseInfo.building,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.userBase.baseInfo.building) = $event)),
                    placeholder: "建物（階数, 部屋番号）"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.address), 513), [
              [_vShow, errors.address]
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.building), 513), [
              [_vShow, errors.building]
            ]),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createVNode(_component_Field, {
                    type: "text",
                    id: "tel",
                    name: "tel",
                    modelValue: _ctx.userBase.baseInfo.tel,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.userBase.baseInfo.tel) = $event)),
                    placeholder: "00012345678",
                    autocomplete: "tel"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.tel), 513), [
              [_vShow, errors.tel]
            ]),
            _createElementVNode("div", _hoisted_89, [
              _hoisted_90,
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("label", _hoisted_92, [
                  _createVNode(_component_Field, {
                    type: "checkbox",
                    modelValue: _ctx.agreement,
                    value: true,
                    "unchecked-value": false,
                    name: "agreement"
                  }, {
                    default: _withCtx(({ field }) => [
                      _withDirectives(_createElementVNode("input", _mergeProps({
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.agreement) = $event)),
                        type: "checkbox"
                      }, field, { id: "agreement" }), null, 16), [
                        [_vModelCheckbox, _ctx.agreement]
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("span", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'Terms' },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_93
                      ]),
                      _: 1
                    }),
                    _hoisted_94,
                    _hoisted_95,
                    _hoisted_96
                  ])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.agreement), 513), [
              [_vShow, errors.agreement]
            ]),
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("button", {
                class: "c-btn is-submit",
                disabled: !meta.valid
              }, _hoisted_100, 8, _hoisted_98)
            ])
          ])
        ]),
        _createElementVNode("input", {
          ref: "fileUploadRef",
          type: "file",
          onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.setImage($event))),
          accept: "image/*",
          style: {"visibility":"hidden","position":"absolute","top":"-200px"}
        }, null, 544)
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}